<template>
  <v-card class="card-shadow mt-4 border-radius-xl">
    <v-card-title class="pb-0 d-flex align-center px-4 pt-4">
      <h6 class="mb-0 text-h6 text-typo font-weight-bold">其他設定</h6>
      <v-spacer></v-spacer>
      <template v-if="!isCreateMode">
        <template v-if="!edit">
          <v-btn icon @click="startEdit" :ripple="false">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-btn icon class="mr-2" @click="cancelEdit" :ripple="false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn icon :loading="saving" @click="submit" :ripple="false">
            <v-icon color="red">mdi-content-save</v-icon>
          </v-btn>
        </template>
      </template>
    </v-card-title>
    <v-card-text class="px-4 pb-4">
      <v-row>
        <v-col cols="12" md="6" v-if="false">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >身分證字號</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.owner_identity || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.owner_identity"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6" v-if="false">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >財務資訊建立時間</v-list-item-subtitle
              >
              <v-list-item-title class="text-typo">{{
                formatDate(companyData.create_time) || "暫無資料"
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6" v-if="false">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >財務資訊修改時間</v-list-item-subtitle
              >
              <v-list-item-title class="text-typo">{{
                formatDate(companyData.modify_time) || "暫無資料"
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6" v-if="false">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >負責人</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.owner_name || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.owner_name"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6" v-if="false">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >負責人電子郵件</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.owner_email || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.owner_email"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >加班倍率</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                overtimeRatiosDisplay
              }}</v-list-item-title>
              <div v-else>
                <v-btn
                  small
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-primary
                    bg-gradient-default
                    py-3
                    px-6
                  "
                  @click="openOvertimeDialog"
                  >編輯加班倍率</v-btn
                >
                <span class="ml-2 text-caption">{{
                  overtimeRatiosShortHint
                }}</span>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >封存日（每月）</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.archive_day_of_month == null
                  ? "暫無資料"
                  : companyData.archive_day_of_month
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model.number="form.archive_day_of_month"
                type="number"
                min="1"
                max="31"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >請假補件截止（小時）</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.report_back_deadline_hours == null
                  ? "暫無資料"
                  : companyData.report_back_deadline_hours
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model.number="form.report_back_deadline_hours"
                type="number"
                min="0"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >加班獎勵政策</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                overtimeRewardPolicyDisplay
              }}</v-list-item-title>
              <v-select
                v-else
                v-model="form.overtime_reward_policy"
                :items="overtimeRewardPolicyItems"
                dense
                hide-details="auto"
              ></v-select>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >公司-自訂加給</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyExtraSalaryDisplay
              }}</v-list-item-title>
              <div v-else>
                <v-btn
                  small
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                    font-weight-bold
                    text-capitalize
                    btn-primary
                    bg-gradient-default
                    py-3
                    px-6
                  "
                  @click="openCompanyExtraSalaryDialog"
                  >編輯自訂加給</v-btn
                >
                <span class="ml-2 text-caption">{{
                  companyExtraSalaryShortHint
                }}</span>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <!-- overtime_ratios -->

        <v-dialog v-model="showOvertimeDialog" max-width="600">
          <v-card>
            <v-card-title class="text-h6">加班倍率</v-card-title>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      type="number"
                      step="0.01"
                      dense
                      label="平日 0-2 小時"
                      v-model.number="overtimeDraft.work_0_2"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      type="number"
                      step="0.01"
                      dense
                      label="平日 2-4 小時"
                      v-model.number="overtimeDraft.work_2_4"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      type="number"
                      step="0.01"
                      dense
                      label="休息日 0-2 小時"
                      v-model.number="overtimeDraft.rest_0_2"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      type="number"
                      step="0.01"
                      dense
                      label="休息日 2-8 小時"
                      v-model.number="overtimeDraft.rest_2_8"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      type="number"
                      step="0.01"
                      dense
                      label="休息日 8-12 小時"
                      v-model.number="overtimeDraft.rest_8_12"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      type="number"
                      step="0.01"
                      dense
                      label="國定假日 0-8 小時"
                      v-model.number="overtimeDraft.nat_0_8"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      type="number"
                      step="0.01"
                      dense
                      label="國定假日 9-10 小時"
                      v-model.number="overtimeDraft.nat_9_10"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      type="number"
                      step="0.01"
                      dense
                      label="國定假日 11-12 小時"
                      v-model.number="overtimeDraft.nat_11_12"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeOvertimeDialog">取消</v-btn>
              <v-btn
                elevation="0"
                :ripple="false"
                height="43"
                class="
                  font-weight-bold
                  text-capitalize
                  btn-primary
                  bg-gradient-default
                  py-3
                  px-6
                "
                @click="confirmOvertimeDialog"
                >確認</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="companyExtraSalaryDialog" max-width="720">
          <v-card>
            <v-card-title class="pb-0 d-flex align-center">
              <span class="text-h6">全員工額外薪資設定</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="closeCompanyExtraSalaryDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="d-flex justify-end pb-0">
                  <v-btn
                    color="blue"
                    dark
                    class="white--text"
                    @click="addCompanyExtraSalaryItem"
                  >
                    新增
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-simple-table dense>
                    <thead>
                      <tr>
                        <th class="text-left">加給名稱</th>
                        <th class="text-left">金額</th>
                        <th class="text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, idx) in companyExtraSalaryItems"
                        :key="`comp-extra-${idx}`"
                      >
                        <td style="width: 55%">
                          <v-text-field
                            v-model="row.key"
                            dense
                            hide-details="auto"
                          ></v-text-field>
                        </td>
                        <td style="width: 35%">
                          <v-text-field
                            v-model.number="row.value"
                            type="number"
                            min="0"
                            dense
                            hide-details="auto"
                          ></v-text-field>
                        </td>
                        <td style="width: 10%">
                          <v-btn
                            icon
                            @click="removeCompanyExtraSalaryItem(idx)"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeCompanyExtraSalaryDialog">取消</v-btn>
              <v-btn
                elevation="0"
                :ripple="false"
                height="43"
                class="
                  font-weight-bold
                  text-capitalize
                  btn-primary
                  bg-gradient-default
                  py-3
                  px-6
                "
                @click="confirmCompanyExtraSalaryDialog"
                >確認</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CompanyFinancialInfoWidget",
  props: {
    companyData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    isCreateMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      edit: this.isCreateMode,
      saving: false,
      form: {
        capital_str: "",
        owner_identity: "",
        owner_name: "",
        owner_email: "",
        overtime_ratios: {},
        archive_day_of_month: 1,
        report_back_deadline_hours: 24,
        overtime_reward_policy: "either",
        company_extra_salary: {},
      },
      companyExtraSalaryDialog: false,
      companyExtraSalaryItems: [],
      showOvertimeDialog: false,
      overtimeDraft: {
        work_0_2: 1.34,
        work_2_4: 1.67,
        rest_0_2: 1.34,
        rest_2_8: 1.67,
        rest_8_12: 2.67,
        nat_0_8: 1,
        nat_9_10: 1.34,
        nat_11_12: 1.67,
      },
      defaultOvertimeRatios: {
        work_0_2: 1.34,
        work_2_4: 1.67,
        rest_0_2: 1.34,
        rest_2_8: 1.67,
        rest_8_12: 2.67,
        nat_0_8: 1,
        nat_9_10: 1.34,
        nat_11_12: 1.67,
      },
    };
  },
  watch: {
    companyData: {
      handler() {
        this.resetForm();
      },
      immediate: true,
      deep: true,
    },
    form: {
      handler(newVal) {
        // In create mode, emit changes immediately
        if (this.isCreateMode) {
          this.$emit("save", newVal, () => {});
        }
      },
      deep: true,
    },
  },
  computed: {
    overtimeRewardPolicyItems() {
      return [
        { text: "給付加班費", value: "pay" },
        { text: "給付加班費或補休(二擇一)", value: "either" },
        { text: "給付加班費及補休(限國定假日)", value: "both" },
      ];
    },
    overtimeRewardPolicyDisplay() {
      const v = this.companyData && this.companyData.overtime_reward_policy;
      if (!v) return "暫無資料";
      const map = {
        pay: "給付加班費",
        either: "給付加班費或補休(二擇一)",
        both: "給付加班費及補休(限國定假日)",
      };
      return map[v] || v;
    },
    overtimeRatiosSource() {
      const src = this.edit
        ? this.form.overtime_ratios
        : this.companyData.overtime_ratios;
      return src && typeof src === "object" ? src : null;
    },
    overtimeRatiosDisplay() {
      const obj = this.overtimeRatiosSource;
      if (!obj) return "暫無資料";
      const parts = [];
      const fmt = (n) => {
        const v = parseFloat(n);
        return isNaN(v) ? "-" : v.toFixed(2);
      };
      if (obj.work_0_2 != null || obj.work_2_4 != null) {
        parts.push(`平日 ${fmt(obj.work_0_2)}/${fmt(obj.work_2_4)}`);
      }
      if (
        obj.rest_0_2 != null ||
        obj.rest_2_8 != null ||
        obj.rest_8_12 != null
      ) {
        parts.push(
          `休 ${fmt(obj.rest_0_2)}/${fmt(obj.rest_2_8)}/${fmt(obj.rest_8_12)}`
        );
      }
      if (
        obj.nat_0_8 != null ||
        obj.nat_9_10 != null ||
        obj.nat_11_12 != null
      ) {
        parts.push(
          `國 ${fmt(obj.nat_0_8)}/${fmt(obj.nat_9_10)}/${fmt(obj.nat_11_12)}`
        );
      }
      return parts.length ? parts.join("，") : "暫無資料";
    },
    overtimeRatiosShortHint() {
      // Same as display but always based on current form for edit context
      const obj =
        this.form &&
        this.form.overtime_ratios &&
        typeof this.form.overtime_ratios === "object"
          ? this.form.overtime_ratios
          : {};
      const parts = [];
      const fmt = (n) => {
        const v = parseFloat(n);
        return isNaN(v) ? "-" : v.toFixed(2);
      };
      parts.push(`平日 ${fmt(obj.work_0_2)}/${fmt(obj.work_2_4)}`);
      parts.push(
        `休 ${fmt(obj.rest_0_2)}/${fmt(obj.rest_2_8)}/${fmt(obj.rest_8_12)}`
      );
      parts.push(
        `國 ${fmt(obj.nat_0_8)}/${fmt(obj.nat_9_10)}/${fmt(obj.nat_11_12)}`
      );
      return parts.join("，");
    },
    companyExtraSalaryDisplay() {
      const obj =
        this.companyData &&
        this.companyData.company_extra_salary &&
        typeof this.companyData.company_extra_salary === "object"
          ? this.companyData.company_extra_salary
          : null;
      if (!obj || Object.keys(obj).length === 0) return "暫無資料";
      return Object.entries(obj)
        .map(([key, value]) => {
          const val = Number(value) || 0;
          return `${key}:${val.toLocaleString()}`;
        })
        .join("，");
    },
    companyExtraSalaryShortHint() {
      const obj =
        this.form &&
        this.form.company_extra_salary &&
        typeof this.form.company_extra_salary === "object"
          ? this.form.company_extra_salary
          : {};
      if (Object.keys(obj).length === 0) return "未設定";
      return Object.entries(obj)
        .map(([key, value]) => {
          const val = Number(value) || 0;
          return `${key}:${val.toLocaleString()}`;
        })
        .join("，");
    },
  },
  methods: {
    resetForm() {
      this.form = {
        capital_str: this.companyData.capital_str || "",
        owner_identity: this.companyData.owner_identity || "",
        owner_name: this.companyData.owner_name || "",
        owner_email: this.companyData.owner_email || "",
        overtime_ratios: this.companyData.overtime_ratios || {},
        archive_day_of_month:
          this.companyData.archive_day_of_month == null
            ? 1
            : this.companyData.archive_day_of_month,
        report_back_deadline_hours:
          this.companyData.report_back_deadline_hours == null
            ? 24
            : this.companyData.report_back_deadline_hours,
        overtime_reward_policy:
          this.companyData.overtime_reward_policy || "either",
        company_extra_salary: this.companyData.company_extra_salary || {},
      };

      // Handle company_extra_salary parsing if needed
      if (typeof this.form.company_extra_salary === "string") {
        try {
          this.form.company_extra_salary = JSON.parse(
            this.form.company_extra_salary
          );
        } catch (e) {
          this.form.company_extra_salary = {};
        }
      }
    },
    openOvertimeDialog() {
      const base = this.defaultOvertimeRatios;
      const cur =
        this.form.overtime_ratios &&
        typeof this.form.overtime_ratios === "object"
          ? this.form.overtime_ratios
          : {};
      this.overtimeDraft = { ...base, ...cur };
      this.showOvertimeDialog = true;
    },
    closeOvertimeDialog() {
      this.showOvertimeDialog = false;
    },
    confirmOvertimeDialog() {
      const cleaned = { ...this.overtimeDraft };
      Object.keys(this.defaultOvertimeRatios).forEach((k) => {
        const v = cleaned[k];
        const n = typeof v === "number" ? v : parseFloat(v);
        cleaned[k] = isNaN(n) ? this.defaultOvertimeRatios[k] : n;
      });
      this.form.overtime_ratios = cleaned;
      this.showOvertimeDialog = false;
    },
    startEdit() {
      this.edit = true;
      this.resetForm();
    },
    cancelEdit() {
      this.edit = false;
      this.resetForm();
    },
    submit() {
      if (this.saving) return;
      this.saving = true;
      const payload = { ...this.form };
      this.$emit("save", payload, (ok) => {
        this.saving = false;
        if (ok) this.edit = false;
      });
    },
    openCompanyExtraSalaryDialog() {
      const data = this.form.company_extra_salary;
      this.companyExtraSalaryItems =
        data && typeof data === "object"
          ? Object.keys(data).map((k) => ({
              key: k,
              value: Number(data[k]) || 0,
            }))
          : [];
      this.companyExtraSalaryDialog = true;
    },
    closeCompanyExtraSalaryDialog() {
      this.companyExtraSalaryDialog = false;
      this.companyExtraSalaryItems = [];
    },
    addCompanyExtraSalaryItem() {
      this.companyExtraSalaryItems.push({ key: "", value: 0 });
    },
    removeCompanyExtraSalaryItem(idx) {
      this.companyExtraSalaryItems.splice(idx, 1);
    },
    confirmCompanyExtraSalaryDialog() {
      const map = {};
      this.companyExtraSalaryItems
        .filter(
          (it) =>
            (it?.key || "").toString().trim() !== "" ||
            (Number(it?.value) || 0) > 0
        )
        .forEach((it) => {
          const k = (it?.key || "").toString().trim() || "未命名";
          const v = Number(it?.value) || 0;
          map[k] = v;
        });
      this.form.company_extra_salary = map;
      this.closeCompanyExtraSalaryDialog();
    },
    formatDate(dateString) {
      if (!dateString) return "暫無資料";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "無效日期";
      return date.toLocaleDateString("zh-TW", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
  },
};
</script>
